import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import FocusableButton from './FocusableButton';

export default React.forwardRef(function Search(props, ref) {
  const {
    containerProps,
    children,
    type,
    onChange,
    onSearch,
    onFocus,
    onBlur,
    value,
    ...rest
  } = props || {};

  const [focused, setFocused] = React.useState(false);
  const onLocalFocus = React.useCallback((e) => {
    setFocused(() => true);
    onFocus && onFocus(e);
  }, [onFocus]);
  const onLocalBlur = React.useCallback((e) => {
    setFocused(() => false);
    onBlur && onBlur(e);
  }, [onBlur]);

  return (
    <div
      {...ex(['Search', { focused, empty: !(value || '').length }], {
        ...containerProps,
      })}
    >
      <input
        {...{ ref }}
        {...{
          tabIndex: 0,
          type: 'text',
          onFocus: onLocalFocus,
          onBlur: onLocalBlur,
          value,
          onChange,
        }}
        {...rest}
      />
      {children}
      <FocusableButton {...{ onClick: onSearch }}>
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20.9999 21L16.6499 16.65" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </FocusableButton>
    </div>
  );
});
